<template>
  <div id="app">
    <theme-styles />
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import '@/css/main.scss'
import ThemeStyles from '@/components/ThemeStyles.vue'

export default {
  name: "App",
  components: {
    ThemeStyles
  },
  beforeMount () {
    // 调试模式检测
    const debug = this.$global.GetQueryString('db');
    if (debug) {
      this.$store.commit('setDebug', true);
    }

    // 设备类型检测和存储
    const deviceType = this.detectDeviceType();
    this.$store.commit('setDeviceType', deviceType);
    this.applyDeviceClass(deviceType);

    // 初始化品牌列表数据
    this.initBrandList();
  },
  methods: {
    applyDeviceClass (deviceType) {
      if (typeof document === 'undefined') return;
      const root = document.documentElement;
      root.classList.remove(
        'detect_deviece_pc',
        'detect_deviece_desktop',
        'detect_deviece_mobile',
        'detect_deviece_tablet',
        'state_pc',
        'state_desktop',
        'state_mobile',
        'state_tablet'
      );
      root.classList.add(`detect_deviece_${deviceType}`);
      root.classList.add(`state_${deviceType}`);
    },
    // 初始化品牌列表数据
    async initBrandList () {
      // 如果品牌列表已加载，则不重复请求
      if (this.$store.getters.brandListLoaded) {
        console.log('品牌列表已加载，不再重复请求');
        return;
      }

      try {
        console.log('App.vue 初始化获取品牌列表');
        // 获取webIndex
        const webIndex = this.$store.getters.domainConfig?.webIndex || 1;
        const response = await this.$global.server.getCarNameList({ webIndex });

        // 确保响应成功且数据格式正确
        if (response && response.code === 200 && response.data) {
          let brands = [];

          // 处理可能的不同响应格式
          if (Array.isArray(response.data)) {
            brands = response.data;
          } else if (response.data.list && Array.isArray(response.data.list)) {
            brands = response.data.list;
          }

          if (brands.length > 0) {
            // 确保返回的数据包含name和value
            const formattedBrands = [
              { label: 'All', value: 'all' },
              ...brands.map(item => ({
                label: item.name || item.label || item,
                value: item.value || item.name || item
              }))
            ];

            // 存储到Vuex中
            this.$store.commit('SET_BRAND_LIST', formattedBrands);
            this.$store.commit('SET_BRAND_LIST_LOADED', true);

            console.log('品牌列表获取成功并已存储到Vuex中');
          }
        } else {
          console.error('获取品牌列表失败', response);
        }
      } catch (error) {
        console.error('获取品牌列表出错', error);
      }
    },
    detectDeviceType () {
      try {
        // SSR 环境检测
        if (typeof this.$ssrContext !== 'undefined' && this.$ssrContext.device) {
          return this.$ssrContext.device;
        }

        // 客户端环境检测
        if (typeof window !== 'undefined') {
          const userAgent = navigator.userAgent.toLowerCase();

          // 平板设备检测
          const isTablet = /ipad|tablet|(android(?!.*mobile))/i.test(userAgent);
          if (isTablet) return 'tablet';

          // 移动设备检测
          const isMobile = /mobile|android|iphone|phone|webos|ipod|blackberry|windows phone/i.test(userAgent);
          if (isMobile) return 'mobile';

          // 增加触摸设备检测作为辅助判断
          const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          if (hasTouch && window.innerWidth < 768) return 'mobile';
        }

        return 'desktop';
      } catch (error) {
        console.warn('设备类型检测失败:', error);
        return 'desktop'; // 发生错误时返回默认值
      }
    }
  }
};
</script>
